(() => {
  const buyForm = document.getElementById('buy-form');
  const orderPanel = document.getElementById('order-panel');
  const qtyEl = document.getElementById('order-qty');
  const lineTotalEl = document.getElementById('order-line-total');
  const totalEl = document.getElementById('order-total');
  const checkoutBtn = document.getElementById('checkout-btn');

  if (!buyForm) return;

  const unitCents = window.SURFSHOT?.unitPriceCents ?? 0;
  const variantId = window.SURFSHOT?.variantId;
  let qty = 1;

  const fmt = (cents) =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' })
      .format(cents / 100);

  const render = () => {
    qtyEl.textContent = qty;
    lineTotalEl.textContent = fmt(unitCents * qty);
    totalEl.textContent = fmt(unitCents * qty);
  };

  buyForm.addEventListener('submit', (e) => {
    e.preventDefault();
    orderPanel.hidden = false;
    render();
    orderPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  orderPanel.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    qty = Math.max(1, qty + Number(step.dataset.qtyStep));
    render();
  });

  checkoutBtn.addEventListener('click', async (e) => {
    e.preventDefault();
    checkoutBtn.textContent = 'Working…';
    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      window.location.href = '/checkout';
    } catch (err) {
      checkoutBtn.textContent = 'Checkout';
      alert('Could not start checkout. Please try again.');
    }
  });
})();
